import { render, staticRenderFns } from "./AddNewIncotermsPopUp.vue?vue&type=template&id=3d936b2a&scoped=true&"
import script from "./AddNewIncotermsPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewIncotermsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewIncotermsPopUp.vue?vue&type=style&index=0&id=3d936b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d936b2a",
  null
  
)

export default component.exports